import React from 'react';
import { Image } from 'semantic-ui-react';
import logo from '../../assets/navbarLogo.svg';

const NavbarLogo = (): React.ReactElement => {
	return <Image src={logo} />;
};

export default NavbarLogo;
